import React,{Fragment} from 'react'
import * as moment from 'moment'
import {deleteInstance} from '../../services/dataService';
import { useState } from 'react';


export default function FormCard( {handleRefresh, history, name, instances, ...addProps} ) {

    const [deleteMode, setDeleteMode] = useState(false);

    console.log(addProps);
    const defaultTableHeader = 
    <tr>
        <th></th>
        <th>Status</th>
        <th>Created On</th>
        <th>Last Updated On</th>
        <th>Last Updated By</th>
        <th>Completed On</th>                        
    </tr>


 const defaultTableBody = (data) =>
    <tr>
        <td><div><input type="button" className="form-card-edit-button" value="Edit" /></div></td>
        <td>{data.status}</td>
        <td>{data.startedDate && moment(data.startedDate+"Z").format('MM/DD/YYYY')}</td>
        <td>{data.lastUpdatedDate && moment(data.lastUpdatedDate+"Z").format('MM/DD/YYYY')}</td>                    
        <td>{data.lastUpdatedBy}</td>
        <td>{data.completedDate && moment(data.completedDate+"Z").format('MM/DD/YYYY')}</td>     
    </tr>

const defaultCardHeader = (name) =>
   <div className="card-header form-card-header" style={{fontWeight:"700px"}}>
        <div>{name}</div>        
    </div>


    const viewOrEditModeButtons=(data)=>{
            
        return(
            <Fragment>
                {true ?
                    <span style={{paddingRight:"20px"}}><input type="button" className="form-card-edit-button" value="View"/></span>              
                    :
                    <span style={{paddingRight:"20px"}}><input type="button" className="form-card-edit-button" onClick={()=>history.push(`/home/form/${true}`)} value="Edit"/></span>
                }
                {data.userCreatedFlag &&
                    <input type="button" className="form-card-edit-button" value="Delete"  onClick={()=>setDeleteMode(true)}/> 
                }
            </Fragment>
        );
    }


    const deleteModeButtons=(data)=>{
            
        return(
        <Fragment>        
            <label className="form-card-delete-label"> Are you sure ? </label>
            <span style={{paddingRight:"20px"}} >
                <input type="button" className="form-card-edit-button form-card-delete-button" value="Delete"  onClick={()=>deleteForm(data.formId)}/> 
            </span>
            <input type="button" className="form-card-edit-button form-card-delete-cancel-button" value="Cancel"  onClick={()=>setDeleteMode(false)}/> 
        </Fragment>
        );
    }

    const deleteForm = async (formId) => {
        await deleteInstance(formId);
        handleRefresh();
    }

    return (
        <div className="card form-card">
            
            { addProps.cardHeader && addProps.cardHeader(name) || defaultCardHeader && defaultCardHeader(name)}
            
            <div className="card-body">
                <table id="form-table">
                <thead>
                    {addProps.tableHeader || defaultTableHeader}
                </thead>
                <tbody>
                    {
                    instances.map(instance => 
                        addProps.tableBody && addProps.tableBody(instance) || defaultTableBody && defaultTableBody(instance))
                    }                    
                </tbody>
                </table>
            </div>
        </div>
    )
}

